import { render, staticRenderFns } from "./TagList.vue?vue&type=template&id=28228a0d"
import script from "./TagList.vue?vue&type=script&lang=js"
export * from "./TagList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\_ASNET\\01_projects\\05_chatannie\\01_git\\chatbot\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28228a0d')) {
      api.createRecord('28228a0d', component.options)
    } else {
      api.reload('28228a0d', component.options)
    }
    module.hot.accept("./TagList.vue?vue&type=template&id=28228a0d", function () {
      api.rerender('28228a0d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TagList/TagList.vue"
export default component.exports